


// import React from 'react';

// interface VideoPlayerProps {
//   videoSrc: string; // The source URL or path of the video
//   backgroundClass?: string; // Optional Tailwind CSS classes for background customization
// }

// const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoSrc, backgroundClass }) => {
//   return (
//     <div className={`relative flex items-center h-96 justify-center ${backgroundClass || 'bg-gray-900'}`}>
//       {/* Custom Shape Divider */}
//       <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0] z-0">
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           viewBox="0 0 1200 120"
//           preserveAspectRatio="none"
//           className="relative block w-[calc(100%+1.3px)] h-[133px]"
//         >
//           <path d="M1200 0L0 0 598.97 114.72 1200 0z" className="fill-white"></path>
//         </svg>
//       </div>

//       {/* Video Player */}
//       <div className="max-w-4xl w-full p-4 bg-gray-800 rounded-lg shadow-lg z-10">
//         <video
//           className="w-full rounded-lg"
//           controls
//           autoPlay
//           muted
//           playsInline
//           onError={(e) => console.error('Error loading video:', e)}
//         >
//           <source src={videoSrc} type="video/mp4" />
//           <source src={videoSrc.replace('.mp4', '.webm')} type="video/webm" />
//           Your browser does not support the video tag.
//         </video>
//       </div>
//     </div>
//   );
// };

// export default VideoPlayer;


import React from 'react';


interface VideoPlayerProps {
  videoSrc: string; // The source URL or path of the video
  backgroundClass?: string; // Optional Tailwind CSS classes for background customization
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoSrc, backgroundClass }) => {
  return (
    <div className={`relative flex items-center h-96 lg:h-96 justify-center ${backgroundClass || 'bg-gray-900'}`}>
      {/* Custom Shape Divider */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0] z-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          className="relative block w-[calc(100%+1.3px)] h-[133px]"
        >
          <path d="M1200 0L0 0 598.97 114.72 1200 0z" className="fill-white"></path>
        </svg>
      </div>

      {/* Video Player */}
      <div className="max-w-4xl w-full p-1 lg:p-8 bg-gray-800 rounded-lg shadow-lg z-10 ">
        <video
          className="w-full rounded-lg h-64 lg:h-96"
          controls
          autoPlay
          muted
          playsInline
          onError={(e) => console.error('Error loading video:', e)}
        >
          <source src={videoSrc} type="video/mp4" />
          <source src={videoSrc.replace('.mp4', '.webm')} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default VideoPlayer;
